<mat-card
  class="top-card banner-card mat-elevation-z0 no-parent-padding"
  [ngClass]="backgroundClass"
>
  <div class="banner-header">
    <span class="strong">{{
      project.collaborative ? 'Gezamenlijke aanvraag: ' : 'Aanvraag: '
    }}</span>
    <span *ngIf="createdMoment != null" class="strong">{{
      createdMoment | formatMoment: '':momentFormat
    }}</span>
  </div>
  <div class="small-upper-space">
    <div *ngFor="let pcg of projectContactGroups; let first = first">
      <div class="d-flex" [ngClass]="!first ? 'smaller-upper-space' : ''">
        <div class="strong">{{ pcg.company.regularName }} -</div>
        <div>
          <div *ngFor="let contact of pcg.contacts">
            <span
              >&nbsp;{{
                contact.firstName | personName: contact.lastName
              }}</span
            >
            <span
              *ngIf="contact.phoneNumberDisplay?.length > 0"
              class="preserve-span-space"
            >
              /
              <a
                class="click-link"
                href="tel:{{ contact.phoneNumberDisplay }}"
                >{{ contact.phoneNumberDisplay }}</a
              >
            </span>
            <span
              *ngIf="contact.mobileNumberDisplay?.length > 0"
              class="preserve-span-space"
            >
              /
              <a
                class="click-link"
                href="tel:{{ contact.mobileNumberDisplay }}"
                >{{ contact.mobileNumberDisplay }}</a
              >
            </span>
            <span
              *ngIf="contact.emailDisplay?.length > 0"
              class="preserve-span-space"
            >
              /
              <a
                class="click-link"
                href="{{
                  contact.emailDisplay
                    | mailSubjectBodyLink
                      : project.id
                      : contact.firstName
                      : subProject.projectPlacement?.address?.line1
                      : subProject.projectPlacement?.address?.postalCode
                      : subProject.projectPlacement?.address?.city
                      : ''
                      : 'Job'
                }}"
              >
                {{ contact.emailDisplay }}
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showExtraCompanyContacts" class="upper-space">
    <div
      *ngFor="let extraCompanyContact of project.projectExtraCompanyContacts"
    >
      <div class="strong">Bedrijfsnaam + contactpersoon</div>
      <div>{{ extraCompanyContact.company }}</div>
      <div>{{ extraCompanyContact.contact }}</div>
    </div>
  </div>
</mat-card>
